// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3427":"829c9b8a81d6ad67","7719":"6a92fc95ebdb6068"}[chunkId] + ".css";
};